// ── Exceptions panel — loads & shows exceptions for a field exam ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { fmtDate } from "../../../shared/format";
import { Btn, Card, Field, Icon, Spinner, Td, Th } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";
import { ExceptionForm } from "./ExceptionForm";

export const ExceptionsPanel = ({ entry }) => {
    const { api, delRec, role, setConfirm } = useApp();
      const [rows, setRows]       = useState([]);
      const [loading, setLoading] = useState(true);
      const [excEntry, setExcEntry] = useState(null);   // exception opened in ExceptionForm
      const canEditHere = role.canEdit;
    
      const load = () => {
        setLoading(true);
        api.get("getCovenantExceptions?covenantcalendarid=" + entry.id)
          .then(setRows).catch(()=>setRows([])).finally(()=>setLoading(false));
      };
      useEffect(()=>{ if (entry?.id) load(); }, [entry?.id]);
    
      // Merge this entry's context (company / covenant / dates) onto an exception row
      const ctx = (r={}) => ({
        ...r,
        covenantcalendarid: entry.id,
        companyname: entry.companyname,
        covenantname: entry.covenantname,
        testdate: entry.testdate,
        duedate: entry.duedate,
        issue: r.issue || "",
        pmresponse: r.pmresponse || ""
      });
    
      const del = (id) => setConfirm({
        msg:"Delete this exception?",
        onConfirm:()=>delRec("CovenantExceptions", id, "Deleted covenant exception", load)
      });
    
      return <div style={{ marginTop:18 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1.5px solid "+B.cyanLight, paddingBottom:4, marginBottom:8 }}>
          <div style={{ fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em" }}>
            Field Exam Exceptions ({rows.length})
          </div>
          {canEditHere && <Btn onClick={()=>setExcEntry(ctx())}>+ Add Exception</Btn>}
        </div>
    
        {loading ? <Spinner /> : <Card style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>
              <Th>Company Name</Th><Th>Covenant Name</Th><Th>Test Date</Th><Th>Due Date</Th><Th>Issue</Th><Th>PM Response</Th>{canEditHere && <Th></Th>}
            </tr></thead>
            <tbody>
              {rows.map(r=>(
                <tr key={r.id} style={{ cursor:"pointer" }}
                  onClick={()=>setExcEntry(ctx(r))}
                  onMouseEnter={ev=>ev.currentTarget.style.background="var(--color-background-secondary)"}
                  onMouseLeave={ev=>ev.currentTarget.style.background=""}>
                  <Td>{entry.companyname||"—"}</Td>
                  <Td>{entry.covenantname||"—"}</Td>
                  <Td>{fmtDate(entry.testdate)}</Td>
                  <Td>{fmtDate(entry.duedate)}</Td>
                  <Td style={{ whiteSpace:"normal", maxWidth:260 }}>{r.issue||"—"}</Td>
                  <Td style={{ whiteSpace:"normal", maxWidth:260 }}>{r.pmresponse||"—"}</Td>
                  {canEditHere && <Td><div style={{ display:"flex", gap:6, justifyContent:"flex-end" }} onClick={ev=>ev.stopPropagation()}>
                    <Btn onClick={()=>setExcEntry(ctx(r))}><Icon type="edit" /></Btn>
                    {role.canDelete && <Btn variant="danger" onClick={()=>del(r.id)}><Icon type="delete" /></Btn>}
                  </div></Td>}
                </tr>
              ))}
              {rows.length===0 && <tr><td colSpan={canEditHere?7:6} style={{ padding:12, fontSize:13, color:"var(--color-text-secondary)" }}>No exceptions.</td></tr>}
            </tbody>
          </table>
        </Card>}
    
        {excEntry && <ExceptionForm initial={excEntry} onClose={()=>setExcEntry(null)} onSaved={load} />}
      </div>;
    };
